import storageUtil from '@zet/utils/storage'

export const experimentsDefaultFallBack = {
  UI_isAddCustomerNewFlow: true,
  UI_IsNewRecommendation: true,
  UI_isNewUserTasks: false,
  UI_isNewHomepage: false,
  UI_isSpotlight: false,
  UI_isPlatfromFeeEnabled: false,
  UI_isRaiseComplaint: false,
  UI_SHOW_MAGNET_BANNER: false,
  UI_MAGNET_TEXT: false,
}

export const getExperimentsFallBackData = () => {
  const experiments = storageUtil.getObject('experiments')
  return {
    ...experimentsDefaultFallBack,
    ...(experiments ? experiments : {}),
  }
}
